export const SUBWORKSTREAM_DUPLICATE_ERROR_KEY = 'sub_workstream_duplicate_error';
export const SUBWORKSTREAM_SELF_ERROR_KEY = 'sub_workstream_self_error';

export const getSubworkstreamSelectionErrorKey = ({
  candidateId,
  blockedWorkstreamIds = [],
  selectedWorkstreamIds = [],
}: {
  candidateId: number;
  blockedWorkstreamIds?: number[];
  selectedWorkstreamIds?: number[];
}) => {
  if (blockedWorkstreamIds.includes(candidateId)) {
    return SUBWORKSTREAM_SELF_ERROR_KEY;
  }

  if (selectedWorkstreamIds.includes(candidateId)) {
    return SUBWORKSTREAM_DUPLICATE_ERROR_KEY;
  }

  return null;
};
